import * as ActionTypes from 'state/types'

export default (state = {
  isRegistered: false
}, action) => {
  switch (action.type) {

    case `${ActionTypes.SUBSCRIBE_PUSH_CLIENT_REQUEST}_SUCCESS`:
      return {
        ...state,
        isRegistered: true
      }

    case ActionTypes.UNSUBSCRIBE_PUSH_CLIENT:
      return {
        ...state,
        isRegistered: false
      }

    default:
      return state
  }
}
